module.exports = __webpack_public_path__ + "static/media/loc3_img3.d2aba4e3.jpg";